module.exports = __webpack_public_path__ + "static/media/activ8.f14b308e.jpg";